/* src/app/feature-modules/student-list/student-details/student-details.component.css */
.matbutton1 {
  margin-left: 250mm;
  margin-right: 2mm;
}
.matbutton2 {
  margin-right: 1mm;
  margin-left: 1mm;
}
.matbutton3 {
  margin-left: 1mm;
}
.mat-mdc-tab {
  margin-bottom: 25mm;
}
.tabs {
  width: 100%;
  border-radius: 4px 4px 0 0;
  background-color: #ffffff;
  border: solid 0.5px #babbc7;
  overflow: hidden;
}
.tab {
  display: inline-block;
  min-width: 130px;
  text-align: center;
  padding: 12px 0;
  color: #81828a;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}
span {
  border-right: 1px solid #eff0f4;
  width: 100%;
  display: inline-block;
  padding: 2px 15px;
  margin-bottom: -3px;
}
.tab.active {
  border-bottom: solid 4px #00b2e2;
  color: #222339;
}
.tab:not(.active):hover {
  color: #222339;
}
.mControls__right {
  display: flex;
  align-items: center;
  gap: 10px;
}
.btn-clear-engagement {
  background-color: #f3a712;
  color: #1f1f1f;
}
.btn-clear-engagement mat-icon {
  color: #1f1f1f;
}
.btn-clear-engagement:hover {
  background-color: #e09b0f;
}
/*# sourceMappingURL=student-details.component.css.map */
